import { render, staticRenderFns } from "./VTextEditor.vue?vue&type=template&id=70c7a3bc&"
import script from "./VTextEditor.vue?vue&type=script&lang=js&"
export * from "./VTextEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports